import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Plotly from "plotly.js-dist-min";
import React, { useEffect, useRef } from "react";
const DEFAULT_COLORS = ["#3b82f6", "#f59e0b", "#10b981", "#ef4444", "#8b5cf6", "#06b6d4", "#f97316", "#ec4899"];
const AiPieChart = ({ colors, labels, title, values }) => {
    const chartRef = useRef(null);
    useEffect(() => {
        if (!chartRef.current)
            return;
        const data = [
            {
                hole: 0,
                hovertemplate: "<b>%{label}</b><br>Value: %{value}<br>%{percent}<extra></extra>",
                labels,
                marker: { colors: colors ?? DEFAULT_COLORS.slice(0, labels.length) },
                textinfo: "label+percent",
                textposition: "inside",
                type: "pie",
                values
            }
        ];
        const layout = {
            autosize: true,
            height: 520,
            legend: { orientation: "h", x: 0.5, xanchor: "center", y: -0.1, yanchor: "top" },
            margin: { b: 80, l: 20, r: 20, t: 10 },
            paper_bgcolor: "transparent",
            showlegend: true
        };
        Plotly.newPlot(chartRef.current, data, layout, { displayModeBar: false, responsive: true });
    }, [colors, labels, values]);
    return (_jsxs("div", { className: "w-full", "data-test": "ai-pie-chart", children: [_jsx("p", { className: "text-base font-semibold text-gray-700 mb-2 text-center", children: title }), _jsx("div", { ref: chartRef })] }));
};
export default AiPieChart;
